// src/state/register/drawers/types.ts
var SET_DRAWERS = "SET_DRAWERS";
var UPDATE_REGISTER_DRAWER = "UPDATE_REGISTER_DRAWER";
var DrawerStatus = /* @__PURE__ */ ((DrawerStatus2) => {
  DrawerStatus2["OPEN"] = "open";
  DrawerStatus2["CLOSED"] = "closed";
  DrawerStatus2["ACTIVE"] = "active";
  DrawerStatus2["CLOCKED_OUT"] = "clocked out";
  return DrawerStatus2;
})(DrawerStatus || {});
var DrawerType = /* @__PURE__ */ ((DrawerType2) => {
  DrawerType2["DEVICE"] = "device";
  DrawerType2["SERVER"] = "server";
  return DrawerType2;
})(DrawerType || {});

export { DrawerStatus, DrawerType, SET_DRAWERS, UPDATE_REGISTER_DRAWER };
